export const toMonthEnd = () => {
  const date = new Date();

  return (33 - new Date(date.getFullYear(), date.getMonth(), 33).getDate()) - date.getDate();
};
